import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';

// import PropTypes from 'prop-types';
import authApi from '../apis/authApi';
import LinkContext from '../context/LinkContext';

// SignIn.propTypes = {
    
// };

function SignIn(props) {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    let navigate = useNavigate();

    const currUrl = useContext(LinkContext);

    const changeUsernameInputValue = (e) => {
        setUsername(e.target.value);
    }
    const changePasswordInputValue = (e) => {
        setPassword(e.target.value);
    }

    // Validation Form
    const validationForm = () => {
        let returnData = {
            error: false,
            msg: ""
        }

        // const {username, password} = this.state;

        // Kiểm tra username
        const re = /\S/;
        if(!re.test(username)) {
            returnData = {
                error: true,
                msg: 'Not match username format'
            }
        }

        // Kiểm tra password dài ít nhất 8 kí tự
        if(password.length < 1) {
            returnData = {
                error: true,
                msg: "Length of password must be greater than 8 character"
            }
        }

        return returnData;
    }

    const fetchSignIn = async () => {
        try{
            const signInData = {
                username: username,
                password: password
            };

            const response = await authApi.post(signInData);

            console.log("Fetch successfully: ", response);

            // console.log("Login success");

            localStorage.setItem("username", username);
            localStorage.setItem("token", response.description);

            navigate(currUrl.curUrl);

            props.onHandleChange();

        } catch(error) {
            console.log("Failed to fetch sign in: ", error);
            alert("Invalid username or password!");
        }
    }

    const submitForm = (e) => {
        e.preventDefault();

        const validation = validationForm();

        if(validation.error) {
            alert(validation.msg);
        } else {
            // alert("Submit form sign in success");
            fetchSignIn();
        }
    }

    return (
        <div>
            <div className="container" style={{paddingTop: "5%"}}>
                <h1 style={{textAlign: "center"}}>
                    Sign in
                </h1>
                <Form
                    onSubmit={(e) => submitForm(e)}
                >
                    <FormGroup>
                        <Label>
                            Username:
                        </Label>
                        <Input
                            type="text"
                            name="username"
                            placeholder="Enter username"
                            onChange={(e) => changeUsernameInputValue(e)}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label>
                            Password:
                        </Label>
                        <Input
                            type="password"
                            name="password"
                            placeholder="Enter password"
                            onChange={(e) => changePasswordInputValue(e)}
                        />
                    </FormGroup>
                    <Button
                        type="submit"
                        color="primary"
                    >
                        Login
                    </Button>
                </Form>
            </div>
        </div>
    );
}

export default SignIn;